/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import Scene from './scenes/ChacmoolScene';
import App from './app/App';

window.app = new App({
  canvas: document.getElementById('gl-canvas'),
  container: document.getElementById('container'),
  scene: new Scene({
    debug: true,
  }),
  showTouches: true,
  showStats: false,
  stats: {
    type: 'fps',
  },
});



// WEBPACK FOOTER //
// ./src/index.js